import type { HazWasteGeneratorStatus } from '../../tri-shared/types/db.ts';

export const GENERATOR_STATUS_LABELS: Record<HazWasteGeneratorStatus, string> = {
  'not-generator': 'Not a generator',
  vsqg: 'VSQG',
  sqg: 'SQG',
  lqg: 'LQG',
};
const rank = { 'not-generator': 0, vsqg: 1, sqg: 2, lqg: 3 };

export function generatorAccumulationDeadlineDays(status: HazWasteGeneratorStatus | null): 90 | 180 | null {
  return status === 'lqg' ? 90 : status === 'sqg' ? 180 : null;
}

export function generatorStatusHigherThan(
  status: HazWasteGeneratorStatus,
  baseline: HazWasteGeneratorStatus | null,
): boolean {
  return baseline != null && rank[status] > rank[baseline];
}

/** Quantities never change automation. Only the profile and explicit acceptances do. */
export function effectiveGeneratorStatus(
  configured: HazWasteGeneratorStatus | null,
  accepted: readonly HazWasteGeneratorStatus[],
): HazWasteGeneratorStatus | null {
  return accepted.reduce<HazWasteGeneratorStatus | null>(
    (result, status) => (result == null || rank[status] > rank[result] ? status : result),
    configured,
  );
}

export function generatorStatusRequirements(status: HazWasteGeneratorStatus): string[] {
  if (status === 'lqg')
    return [
      'Apply 90-day central accumulation deadlines, measured from each container’s existing start date.',
      'Review personnel training, contingency planning, and the Quick Reference Guide for LQG requirements.',
      'Review shipment-specific follow-up and exception-report deadlines for missing signed manifests.',
      'Include this month when reviewing biennial-report applicability for the reporting year.',
    ];
  if (status === 'sqg')
    return [
      'Apply the standard 180-day central accumulation deadline from each container’s existing start date.',
      'Review personnel training and emergency procedures for SQG requirements.',
      'Track missing signed manifests using each shipment’s applicable exception-report deadline.',
    ];
  return ['Keep generation records and review applicable storage and disposal requirements.'];
}
